































































































































































































































































import { vxm } from '@/store.vuex';
import { Component, Vue } from 'vue-property-decorator';
import Jobseeker from './Jobseeker.vue';
import Myreferrals from './Myreferrals.vue';
import Referrals from './Referrals.vue';
import { JobsStore } from '@/models/jobs/jobs.vuex';
import { Job } from '@/models/jobs/job';
import { BFormFile } from 'bootstrap-vue/es/components';
import { SupportingInfoPayload } from '../models/jobs/supportinginfoPayload';
import { JobTokenPayload } from '../models/jobs/jobTokenPayload';
import { UserAttributeWrapper } from '../models/jobs/userattributewrapper';

@Component({
  name: 'SupportingDocuments',
  components: {
    Jobseeker,
    Myreferrals,
    Referrals,
  },
})
export default class SupportingDocuments extends Vue {
  private supportingInfoPayload: SupportingInfoPayload = new SupportingInfoPayload();
  private showDetail: boolean = false;
  private supportingInfo: UserAttributeWrapper = new UserAttributeWrapper();
  private questionaire: any;
  $moment: any;
  mounted() {
    const jobid = this.$route.params.JobID;
    vxm.jobs.getAnonymousJobByID(jobid);
  }

  getDistance(job: Job) {
    if (job.distance > 0.1) {
      return job.distance.toFixed(1);
    } else {
      return '< 0.1';
    }
  }
  getCompanyDistanceUnits(): string {
    if (vxm.jobs.getCompanyDistanceUnit == 'kilometers') {
      return 'km';
    }
    return 'mi';
  }

  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  get SupportingInfo() {
    return vxm.jobs.SupportingInfo;
  }

  get QuestionnaireData() {
    return vxm.jobs.Questionnaire.questions;
  }

  get jobDetail(): Job[] {
    const jobList: Job[] = [];
    jobList.push(vxm.jobs.AnonymousJobByID);
    return jobList;
  }

  saveSupportingInfo() {
    this.supportingInfoPayload.token = vxm.users.getToken;
    this.supportingInfoPayload.jobID = parseInt(this.$route.params.JobID, 10);
    this.supportingInfoPayload.userId = vxm.users.myUserProfile.userId;
    this.supportingInfoPayload.referralCode = vxm.referrals.globalRefCode;
    console.log(this.supportingInfoPayload);
    vxm.jobs.postSupportingInfo(this.supportingInfoPayload);
  }

  getQuestionnaire() {
    const jobId = this.$route.params.JobID;
    const jtp = new JobTokenPayload();
    jtp.token = vxm.users.getToken;
    jtp.jobID = parseInt(jobId, 10);
    vxm.jobs.getQuetionaireListing(jtp);
  }

  goToResumeUpload() {
    this.$router.push({
      name: 'ResumeUpload',
      params: { JobID: this.$route.params.JobID },
    });
  }

  JobID() {
    return parseInt(this.$route.params.JobID, 10);
  }

  toggleReferrals() {
    this.showDetail = !this.showDetail;
  }

  getToggleValue() {
    return this.showDetail;
  }

  truncate(str: string, len: number, suffix: string) {
    if (str.length > len) {
      return str.substring(0, len) + suffix;
    } else {
      return str;
    }
  }

  renderDate(xDate: Date): string {
    if (vxm.jobs.getCompanyDateFormat) {
      return (
        'STARTING: ' +
        this.$moment(xDate).format(vxm.jobs.getCompanyDateFormat.toUpperCase())
      );
    }
    return 'STARTING: ' + this.$moment(xDate).format('DD-MMM-YYYY');
  }
  getCompanyLogoUrl(companyCode: string): string {
    return vxm.jobs.getCompanyLogoUrl(companyCode)
  }

  getFristCapitalletter(value: string): string {
    if (!value) return '';
    value = value.toString();
    return value
      .trim()
      .charAt(0)
      .toUpperCase();
  }
}
